import React from 'react'
import PropTypes from 'prop-types'
import { CheckboxStyle, Label } from '../../../../components/styled/global.style'
import { Box } from '@mui/material'
import { TraderTradingAccountList, TradingAccountTextItem } from '../TraderDetails.style'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

const TraderTradingAccounts = ({ form, handelChange }) => {
  return (
    <>
      <Label>Assignment</Label>
      <TraderTradingAccountList className="container">
        {form.trading_account_names.map(({ trading_account_name, is_active }, index) => (
          <Box key={trading_account_name} style={{ display: 'flex', gap: '4px' }}>
            <CheckboxStyle
              name="trading_account_names"
              checked={!!is_active}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              onChange={event => handelChange(event, index)}
            />
            <TradingAccountTextItem>{trading_account_name}</TradingAccountTextItem>
          </Box>
        ))}
      </TraderTradingAccountList>
    </>
  )
}

export default TraderTradingAccounts

TraderTradingAccounts.propTypes = {
  form: PropTypes.object,
  handelChange: PropTypes.func
}
